import { useEffect, useState } from 'react';

/**
 * Return a debounced version of `value` that only updates after `delayMs`
 * of no further changes. The first render returns the initial value
 * immediately (no waiting).
 */
export function useDebounce<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);

  return debounced;
}
